import * as React from 'react';

import {ButtonCard} from '../card/button-card';
import type {DripEdition} from '../drip-sequence-list-item/drip-sequence-list-item';
import {getDateForDripSequenceHeader} from '../drip-sequence-list-item/get-date-for-drip-sequence-header';
import {DripSequencePreview} from '../drip-sequence-preview/drip-sequence-preview';
import type {DripSequence} from '../drip-sequence-preview/drip-sequence-preview';
import {getEditionStatusInfo} from '../edition/get-edition-status-info';
import {StatusBadge} from '../status-badge/status-badge';
import {DescriptionBody} from '../typography/description-body';

import styles from './drip-sequence-thumbnail.module.css';

export type DripSequenceForThumbnail = {
    name: string;
    status: string;
    createdTime: number;
    lastStatusChangeTime: number | null | undefined;
} & DripSequence;

type Props = {
    dripSequence: DripSequenceForThumbnail;
    dripEditions: DripEdition[];
    onClick?: () => void;
    isSelected?: boolean;
};

export function DripSequenceThumbnail(props: Props) {
    return (
        <div className={styles['drip-sequence-thumbnail']}>
            <ButtonCard fitHeight={true} onClick={props.onClick} isSelected={props.isSelected}>
                <div className={styles['thumbnail-header']}>
                    <div className='truncate'>{props.dripSequence.name}</div>
                    {/* @ts-expect-error */}
                    <StatusBadge {...getEditionStatusInfo(props.dripSequence.status)} />
                    <DescriptionBody>
                        {getDateForDripSequenceHeader({
                            status: props.dripSequence.status,
                            createdTime: props.dripSequence.createdTime,
                            lastStatusChangeTime: props.dripSequence.lastStatusChangeTime,
                        })}
                    </DescriptionBody>
                </div>
                <div className={styles['preview-container']}>
                    <DripSequencePreview
                        dripEditions={props.dripEditions}
                        dripSequence={{
                            startTrigger: props.dripSequence.startTrigger,
                            status: props.dripSequence.status,
                        }}
                        isThumbnail={true}
                    />
                </div>
            </ButtonCard>
        </div>
    );
}
